import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {SmTextareaComponent} from './sm-textarea.component';

@NgModule({
  declarations: [SmTextareaComponent],
  imports: [CommonModule, FormsModule, IonicModule],
  exports: [SmTextareaComponent],
})
export class SmTextareaModule {}
